import { createStore, combineReducers, applyMiddleware } from "redux";
// import { configureStore } from "@reduxjs/toolkit"; // Not used, can be removed
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import {
  userLoginReducer,
  userRegisterReducer,
  userUpdateReducer,
  userUpdateSubscriptionReducer,
  userListReducer,
  userExportReducer,
  userDeleteReducer,
} from "./reducers/userReducers";
import {
  dayCreateReducer,
  dayListReducer,
  dayListIDReducer,
  daySingleReducer,
  dayUpdateReducer,
  dayDeleteReducer,
} from "./reducers/daysReducers";
import { artOfLookingProgressReducer } from "./reducers/quizReducers";
import {
  yearCreateReducer,
  yearUpdateReducer,
  yearListReducer,
  valuesUpdateReducer,
  yearSingleReducer,
} from "./reducers/yearsReducers";
import {
  weeksCreateReducer,
  weekListReducer,
  weekUpdateReducer,
  weekSingleReducer,
} from "./reducers/weekReducers";
import {
  debriefCreateReducer,
  debriefListReducer,
  debriefUpdateReducer,
  debriefDeleteReducer,
} from "./reducers/debriefsReducers";

const reducer = combineReducers({
  // USER REDUCERS
  userLogin: userLoginReducer,
  userRegister: userRegisterReducer,
  userUpdate: userUpdateReducer,
  userUpdateSubscription: userUpdateSubscriptionReducer,
  userList: userListReducer,
  userExport: userExportReducer,
  userDelete: userDeleteReducer,

  // YEAR REDUCERS
  yearList: yearListReducer,
  yearSingle: yearSingleReducer,
  yearCreate: yearCreateReducer,
  yearUpdate: yearUpdateReducer,
  valuesUpdate: valuesUpdateReducer,

  // DAY REDUCERS
  dayList: dayListReducer,
  dayListID: dayListIDReducer,
  dayCreate: dayCreateReducer,
  daySingle: daySingleReducer,
  dayUpdate: dayUpdateReducer,
  dayDelete: dayDeleteReducer,

  // WEEK REDUCERS
  weekCreate: weeksCreateReducer,
  weekList: weekListReducer,
  weekUpdate: weekUpdateReducer,
  weekSingle: weekSingleReducer,

  // QUIZ REDUCERS
  artOfLookingProgress: artOfLookingProgressReducer,

  // DEBRIEF REDUCERS
  debriefList: debriefListReducer,
  debriefCreate: debriefCreateReducer,
  debriefUpdate: debriefUpdateReducer,
  debriefDelete: debriefDeleteReducer,
});

const initialState = {};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware)),
);

export default store;
